import request from '@/utils/request'

/**
 * 获取分销员列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listAffiliateUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateUser.listAffiliateUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除分销员
 * @param {Object} data 删除参数
 * @returns {Promise} Promise对象
 */
export function deleteAffiliateUser(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateUser.deleteAffiliateUser',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function auditAffiliateUser(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateUser.auditAffiliateUser',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}